import getNumberOfSites from './get-number-of-sites';

export default {
  getNumberOfSites,
};
